export const IconThreeDots = `<svg width="16" height="4" viewBox="0 0 16 4" fill="none" xmlns="http://www.w3.org/2000/svg">
<ellipse cx="14.0802" cy="1.872" rx="1.92" ry="1.872" fill="#1FA7EC"/>
<ellipse cx="7.67977" cy="1.872" rx="1.92" ry="1.872" fill="#1FA7EC"/>
<ellipse cx="1.92" cy="1.872" rx="1.92" ry="1.872" fill="#1FA7EC"/>
</svg>
`
